import "whatwg-fetch";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { lazy } from "react";
import { connect } from "react-redux";
import Redirect from "react-router-dom/es/Redirect";
import {
  fetchAssets,
  setAssetTags,
  setPageTitle,
  updateImageAsset,
  updateAudioAsset,
  updateVideoAsset,
  updateAsset,
  transcodeVideo,
  fetchDeviceTags,
  fetchAssetTags,
  addAssetTag,
  deleteAssetTag,
} from "signoxe/actions";
import { EditableLabel, NotificationMessage, Page, AddSaveCancelWidget } from "signoxe/components";
import { Box } from "signoxe/components/layout";
import { Button, Icon, TagList, Popup} from "signoxe/components/widgets";
import Tag from "signoxe/components/widgets/TagsPopup/Tag";

import { getAsset, getProfile, getDeviceTagsAll, getFilteredAssetsByQuery, getAssetTagsAll} from "signoxe/selectors";
import "./styles.scss";
import { API_ROOT, APP_ROOT } from "signoxe/constants/config";
import { VIDEO_RESOURCE } from "signoxe/api/resources";

class AssetPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      metadataDetail: false,
      videoTranscodingStarted: false,
      caption: "",
      touch_target_url: "",
      thumbnail_url: "",
      description: "",
      tagToggled: false,
      searchText: "",
      assetSearchQuery:"",
      assetIDselected:"",
      toggleThumbnail:"",

    };
  }

  static propTypes = {
    fetchAssets: PropTypes.func.isRequired,
    updateAsset: PropTypes.func.isRequired,
    setAssetTags: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    asset: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    fetchDeviceTags: PropTypes.func.isRequired,
    fetchAssetTags: PropTypes.func.isRequired,
    assets: PropTypes.object.isRequired,

  };

  getMetadataTable = (metadata) => (
    <table>
      <tbody>
        {Object.keys(metadata).map((tag, tidx) => (
          <tr key={`metadata-tag-${tidx}`}>
            <th>{tag}:</th>
            <td>{this.infoToString(metadata[tag])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  getStreamInfoBox = (streams, type) =>
    streams &&
    streams.length > 0 && (
      <Box direction="column" className="metadata-info-block">
        <h4>{type} Streams:</h4>
        {streams.map((stream, idx) => (
          <Box direction="column" key={`md-${type}-${idx}`}>
            <h5>
              Stream [
              {stream["Stream Index"] !== undefined
                ? stream["Stream Index"]
                : idx + 1}
              ]:
            </h5>
            {this.getMetadataTable(stream)}
          </Box>
        ))}
      </Box>
    );

  handleSwitchMetadataView = () =>
    this.setState(({ metadataDetail }) => ({
      metadataDetail: !metadataDetail,
    }));

  handleTagAdd = (tag) =>
    this.props.setAssetTags(
      this.props.asset.id,
      this.props.asset.tags.concat(tag)
    );

  handleAddAssetTag = (newName) => {
    this.props.addAssetTag({ name: newName });

  }

  handleDeleteAssetTag = (tag) => {
    this.props.deleteAssetTag(tag.id);

  }
  handleTagRemove = (tagToRemove) =>
    this.props.setAssetTags(
      this.props.asset.id,
      this.props.asset.tags.filter((tag) => tag != tagToRemove)
    );

  onAssetChange = (newAsset) => {
    this.props.updateAsset(this.props.asset.id, { name: newAsset });
  };

  onEdit = () => {
    this.props.history.push(
      `/assets/edit/${this.props.asset.type.toLowerCase()}/${
        this.props.asset.id
      }`
    );
  };

  onFullScreen = () => {
    const previewDOM = this.preview;
    if (previewDOM.requestFullscreen) {
      previewDOM.requestFullscreen();
    } else if (previewDOM.webkitRequestFullscreen) {
      previewDOM.webkitRequestFullscreen();
    } else if (previewDOM.mozRequestFullScreen) {
      previewDOM.mozRequestFullScreen();
    } else if (previewDOM.msRequestFullscreen) {
      previewDOM.msRequestFullscreen();
    }
  };

  static getStreamsOfType(metadata, type) {
    if (metadata[`${type}_streams`] !== undefined) {
      return metadata[`${type}_streams`];
    } else {
      const streams = [];

      if (!metadata.streams) {
        return streams;
      }

      Object.keys(metadata.streams).forEach((streamid) => {
        const stream = metadata.streams[streamid];

        if (stream.codec_type === type) {
          streams.push(stream);
        }
      });
      // for (const streamid in metadata.streams) {
      //   const stream = metadata.streams[streamid];
      //
      //   if (stream.codec_type === type) {
      //     streams.push(stream);
      //   }
      // }

      return streams;
    }
  }

  componentDidMount() {
    this.props.setPageTitle("Asset");
    const asset = this.props.asset;
    if (asset && asset.caption) {
      this.setState({ caption: this.props.asset.caption });
    }
    if (asset && asset.touch_target_url) {
      this.setState({ touch_target_url: this.props.asset.touch_target_url });
    }
    if (asset && asset.description) {
      this.setState({ description: this.props.asset.description });
    }
    if (asset && asset.thumbnail_url) {
      this.setState({ thumbnail_url: this.props.asset.thumbnail_url });
    }
    this.props.fetchDeviceTags(true);
    this.props.fetchAssetTags(true);
  }

  getImageMetadataView(metadata) {
    return (
      <Box wrap direction="row" justifyContent="space-between">
        {Object.keys(metadata).map((mgroup, midx) => (
          <div key={`metadata-group-${midx}`} className="metadata-info-block">
            <h4>{mgroup}:</h4>
            {this.getMetadataTable(metadata[mgroup])}
          </div>
        ))}
      </Box>
    );
  }

  checkAssetType() {
    const defaults = ["IMAGE", "VIDEO", "AUDIO"];
    if (defaults.includes(this.props.asset.type)) {
      return true;
    } else {
      return false;
    }
  }

  saveCaption() {
    const caption = this.state.caption;
    if (caption.length) {
      if (this.props.asset.type === "IMAGE") {
        this.props.updateImageAsset(this.props.asset.id, {
          caption: this.state.caption,
        });
      } else if (this.props.asset.type === "VIDEO") {
        this.props.updateVideoAsset(this.props.asset.id, {
          caption: this.state.caption,
        });
      } else if (this.props.asset.type === "AUDIO") {
        this.props.updateAudioAsset(this.props.asset.id, {
          caption: this.state.caption,
        });
      }
    }
  }

  saveTouchTargetUrl() {
    const touchTargetUrl = this.state.touch_target_url;

    if (this.props.asset.type === "IMAGE") {
      this.props.updateImageAsset(this.props.asset.id, {
        touch_target_url: touchTargetUrl,
      });
    } else if (this.props.asset.type === "VIDEO") {
      this.props.updateVideoAsset(this.props.asset.id, {
        touch_target_url: touchTargetUrl,
      });
    } else if (this.props.asset.type === "AUDIO") {
      this.props.updateAudioAsset(this.props.asset.id, {
        touch_target_url: touchTargetUrl,
      });
    }
  }

  saveDescription() {
    const description = this.state.description;

    if (this.props.asset.type === "IMAGE") {
      this.props.updateImageAsset(this.props.asset.id, {
        description: description,
      });
    } else if (this.props.asset.type === "VIDEO") {
      this.props.updateVideoAsset(this.props.asset.id, {
        description: description,
      });
    } else if (this.props.asset.type === "AUDIO") {
      this.props.updateAudioAsset(this.props.asset.id, {
        description: description,
      });
    }
  }

  handleFileChange = (event) => {
    const file = event.target.files[0]; // assuming you only allow single file selection
    this.setState({ thumbnail: file });
  };

  saveThumbnail() {
    const img_thumbnail = this.state.thumbnail_url;

    if (this.props.asset.type === "IMAGE") {
      this.props.updateImageAsset(this.props.asset.id, {
        thumbnail_url: img_thumbnail,
      });
    } else if (this.props.asset.type === "VIDEO") {
      this.props.updateVideoAsset(this.props.asset.id, {
        thumbnail_url: img_thumbnail,
      });
    } else if (this.props.asset.type === "AUDIO") {
      this.props.updateAudioAsset(this.props.asset.id, {
        thumbnail_url: img_thumbnail,
      });
    }
    this.setState({ toggleThumbnail : !this.state.toggleThumbnail });

    
  }

  getMediaElement() {
    const { asset } = this.props;

    switch (asset.type) {
      case "VIDEO":
        return (
          <video
            title={asset.name}
            allowFullScreen
            controls
            poster={asset.thumbnail}
            ref={(elem) => (this.preview = elem)}
            preload="metadata"
          >
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
            />
          </video>
        );
      case "IMAGE" || "AUDIO":
        return (
          <img
            src={
              asset.asset_url.startsWith("http")
                ? asset.asset_url
                : APP_ROOT + asset.asset_url
            }
            ref={(elem) => (this.preview = elem)}
          />
        );
      case "FEED":
      case "FIDS":
        return (
          <iframe
            src={asset.asset_url}
            ref={(elem) => (this.preview = elem)}
            allowFullScreen
            className="web-preview"
          />
        );
      case "WEB":
        return (
          <iframe
            src={asset.asset_url}
            ref={(elem) => (this.preview = elem)}
            allowFullScreen
            className="web-preview"
          />
        );
      case "URL":
        return <a href={asset.asset_url}>{asset.asset_url}</a>;
      case "CALENDAR":
        return <Redirect to={`/assets/edit/cal/${this.props.asset.id}`} />;
      case "PDF":
        return (
          <embed
            src={
              asset.asset_url.startsWith("http")
                ? asset.asset_url
                : APP_ROOT + asset.asset_url
            }
            type="application/pdf"
            width="100%"
          />
        );
      case "AQI":
        return <code>{asset.asset_url}</code>;
      case "AQI_VEDA":
        return <code>{asset.asset_url}</code>;
      case "ZIP":
        return <code>Preview not available for custom assets</code>;
      case "AUDIO":
        return (
          <audio controls>
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/mpeg"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/ogg"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/wav"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/flac"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/aac"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/wma"
            />
            <source
              src={
                asset.asset_url.startsWith("http")
                  ? asset.asset_url
                  : APP_ROOT + asset.asset_url
              }
              ref={(elem) => (this.preview = elem)}
              type="audio/aiff"
            />
            Your browser does not support the audio element.
          </audio>
        );
      default:
        return <div>Invalid Media Type</div>;
    }
  }

  getMetadataView() {
    const { type, metadata, full_metadata } = this.props.asset;
    const displayData = this.state.metadataDetail ? full_metadata : metadata;

    return (
      displayData && (
        <Box direction="column" className="metadata-view">
          <Box direction="row" justifyContent="space-between">
            <h3>Metadata:</h3>
            <Button
              onClick={this.handleSwitchMetadataView}
              secondary
              className="hollow"
            >
              {this.state.metadataDetail ? "Fewer Details" : "More Details"}
            </Button>
          </Box>
          {type === "IMAGE" && this.getImageMetadataView(displayData)}
          {type === "VIDEO" && this.getVideoMetadataView(displayData)}
        </Box>
      )
    );
  }

  getVideoMetadataView(metadata) {
    console.log("meta-data-fromat", metadata.format);
    return (
      <Box wrap direction="row" justifyContent="space-between">
        {metadata.format && (
          <div className="metadata-info-block">
            <h4>Format:</h4>
            {this.getMetadataTable(metadata.format)}
          </div>
        )}
        {this.getStreamInfoBox(
          AssetPage.getStreamsOfType(metadata, "video"),
          "Video"
        )}
        {this.getStreamInfoBox(
          AssetPage.getStreamsOfType(metadata, "audio"),
          "Audio"
        )}
        {this.getStreamInfoBox(
          AssetPage.getStreamsOfType(metadata, "subtitle"),
          "Subtitle"
        )}
      </Box>
    );
  }

  infoToString(info) {
    const infoType = typeof info;

    if (infoType === "object") {
      return this.getMetadataTable(info);
    } else if (infoType === "array") {
      return info.join(", ");
    } else if (infoType === "string") {
      return info;
    } else return JSON.stringify(info);
  }

  isEditableAsset() {
    return (
      this.props.asset.type === "WEB" ||
      this.props.asset.type === "URL" ||
      this.props.asset.type === "CALENDAR" ||
      this.props.asset.type === "AQI" ||
      this.props.asset.type === "FIDS"
    );
  }

  transcodeVideo(asset) {
    // console.log("ASSSETS:::", asset)
    this.setState({ videoTranscodingStarted: true });
    setTimeout(() => {
      this.setState({ videoTranscodingStarted: false });
    }, 5000);
    this.props.transcodeVideo(asset.id);
    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "same-origin",
    };
    let url = `${API_ROOT}${VIDEO_RESOURCE}/${asset.id}/transcode/`;
    console.log("URL", url);
    return fetch(
      `${API_ROOT}${VIDEO_RESOURCE}/${asset.id}/transcode/`,
      requestOptions
    );
  }

  handleToggleEdit = () => {
    this.setState({ tagToggled: !this.state.tagToggled });
  };

  handleModifyThumbnail = () => {
    this.setState({ toggleThumbnail : !this.state.toggleThumbnail });
  };

  handleAddTag = (tag) =>
    this.props.setAssetTags(
      this.props.asset.id,
      this.props.asset.tags.concat(tag.name)
    );

  handleRemoveTag = (tagToRemove) =>
    this.props.setAssetTags(
      this.props.asset.id,
      this.props.asset.tags.filter((tag) => tag != tagToRemove)
    );
    handleSearch = (event) => {
      this.setState({ searchText: event.target.value });
    };

    handleThumbnailImage = (asset) => {
      this.setState({ thumbnail_url: asset.asset_url });
      this.setState({assetIDselected: asset.id})
    };
  
    handleBgSearch = (e) => {
      this.setState({ assetSearchQuery: e.target.value });
    };


  render() {
    console.log("assetreal", this.props.asset);
    const assetsTags = this.props.asset && this.props.asset.tags;

    const { asset, profile, transcodedVideos } = this.props;
    if (!asset || !asset.type || !asset.name) {
      return <div>Invalid asset.</div>;
    }
    const {assetSearchQuery, thumbnail_url,  assetIDselected, toggleThumbnail } = this.state
    console.log("assetSearchQuery", assetSearchQuery)
    console.log("thumbnail_url", thumbnail_url)

    return (
      <Page className="asset-view-page">
        {asset && (
          <React.Fragment>
            {this.state.videoTranscodingStarted ? (
              <NotificationMessage
                id="video-transcoding-starting-message"
                message="Video is being transcoded to make it more stable. Once finished, you will see the title prefixed with RE-ENCODED."
                kind="info"
              />
            ) : null}
            <Box direction="row" alignItems="center">
              <h2 style={{ display: "flex", flexGrow: 1 }}>
                <EditableLabel
                  value={asset.name}
                  onChange={this.onAssetChange}
                />
              </h2>
              {this.isEditableAsset() && (
                <Icon
                  title="Edit"
                  name="edit"
                  size="2rem"
                  onClick={this.onEdit}
                />
              )}
              {profile &&
                asset.type === "VIDEO" &&
                profile.video_transcoding === 2 &&
                asset.name.indexOf("RE-ENCODED") !== 0 &&
                !transcodedVideos.includes(asset.id) && (
                  <button
                    type="button"
                    className="button"
                    onClick={() => this.transcodeVideo(asset)}
                  >
                    ReEncode
                  </button>
                )}
              {this.props.asset.type === "AQI" ? null : (
                <Icon
                  title="Fullscreen"
                  name="expand"
                  size="2rem"
                  onClick={this.onFullScreen}
                />
              )}
            </Box>
            <Box
              direction="row"
              className={classNames(
                "preview",
                this.props.asset.type.toLowerCase()
              )}
            >
              {this.getMediaElement()}
            </Box>
            {this.checkAssetType() && (
              <>
                <div style={{ marginTop: "1rem" }}>
                  <label for="caption">Add Caption</label>
                  <div className="input-group" style={{ width: "60%" }}>
                    <input
                      name="caption"
                      className="input-group-field"
                      type="text"
                      placeholder="Add Caption"
                      defaultValue={this.props.asset.caption}
                      onChange={(e) =>
                        this.setState({ caption: e.target.value })
                      }
                    />
                    <span
                      className="input-group-label cursor"
                      onClick={(e) => this.saveCaption()}
                    >
                      <Icon title="Save" name="save" size="1rem" />
                    </span>
                  </div>
                </div>
                <div style={{ marginTop: "1rem" }}>
                  <label for="touch_target_url">Add Touch Url</label>
                  <div className="input-group" style={{ width: "60%" }}>
                    <input
                      name="touch_target_url"
                      className="input-group-field"
                      type="text"
                      placeholder="Add Touch Url"
                      defaultValue={this.props.asset.touch_target_url}
                      onChange={(e) =>
                        this.setState({ touch_target_url: e.target.value })
                      }
                    />
                    <span
                      className="input-group-label cursor"
                      onClick={(e) => this.saveTouchTargetUrl()}
                    >
                      <Icon title="Save" name="save" size="1rem" />
                    </span>
                  </div>
                </div>

                <div style={{ marginTop: "1rem" }}>
                  <label for="description">Add Description</label>
                  <div className="input-group" style={{ width: "60%" }}>
                    <input
                      name="description"
                      className="input-group-field"
                      type="text"
                      placeholder="Add Description"
                      defaultValue={this.props.asset.description}
                      onChange={(e) =>
                        this.setState({ description: e.target.value })
                      }
                    />
                    <span
                      className="input-group-label cursor"
                      onClick={() => this.saveDescription()}
                    >
                      <Icon title="Save" name="save" size="1rem" />
                    </span>
                  </div>
                </div>
              
              </>
            )}
           
          <div className="bgImage">
            <label htmlFor="bgImage">Thumbnail Image</label>
              <Box
                  className="caption-box"
                  direction="column"
                  justifyContent="center"
                >
                  {thumbnail_url && (
                    <img
                      src={
                        thumbnail_url
                      }
                      width={250}
                      height={300}
                    />
                  )}
                </Box>
      
            { toggleThumbnail ? <>
              <input
                  type="text"
                  placeholder="Search images..."
                  value={assetSearchQuery}
                  onChange={this.handleBgSearch}
                  style={{width: "64%"}}
              />
              <div className="thumbnail-box" style={{ maxHeight: '15rem', overflowY: 'auto', maxWidth:'64%', marginTop:"1rem" }}>
                  {this.props.assets
                      .filter((asset) => asset.type === "IMAGE")
                      .filter((asset) =>
                          asset.name.toLowerCase().includes(assetSearchQuery.toLowerCase())
                      )
                      .map((asset) => (
                          <div
                              key={asset.id}
                              className={`thumbnail ${
                                  asset.id === assetIDselected ? "tickselected" : ""
                              }`}
                              style={{
                                  backgroundImage: `url(${asset.asset_url})`,
                              }}
                              onClick={() => this.handleThumbnailImage(asset)}
                          >
                              <div className="thumbnail-name">
                                  {asset.name && asset.name.length > 7
                                      ? `${asset.name.slice(0, 7)}..`
                                      : asset.name}
                              </div>
                          </div>
                      ))}
              </div>
              </>: null}
          </div>

         {toggleThumbnail ? 

        <div className="flex flex-jc-sb flex-ai-c" style={{ maxWidth:'64%'}}>

         <button style={{width:'10%', marginBottom:"1rem"}} className="button primary" onClick={() => this.saveThumbnail()}>
             Save
          </button>
          <button style={{width:'10%', marginBottom:"1rem"}} className="button secondary" onClick={this.handleModifyThumbnail}>
             Close
          </button>
         </div>
         
         :

          <button style={{width:'20%', marginBottom:"1rem"}} className="button secondary" onClick={this.handleModifyThumbnail}>
            Edit Thumbnail
          </button>}
  

          <div className="flex flex-ai-c">
            {this.props.asset.type !== "FEED" && (
              <TagList
                tags={this.props.asset.tags}
              />
            )}

            <button style={{width:'10%'}} className="button button-custom-sm secondary" onClick={this.handleToggleEdit}>
              Edit Tags 
            </button>
            </div>

          

            {this.state.tagToggled && (
              <Popup
                className="text-start p-2"
                title="Update Asset Tags"
                style={{width:'40%'}}
                modal
              >
                <div>
              
                <div className="p-2 flex flex-jc-sb flex-ai-c">
                  <div></div>
                  <AddSaveCancelWidget
                    addLabel="Create Asset Tag "
                    onSave={this.handleAddAssetTag}
                  />
                  </div>
              <div className="flex flex-ai-c flex-wrap"  style={{ maxHeight: '11rem', overflowY: 'auto', maxWidth:'100%', }}>

              {this.props.asset &&  this.props.asset.tags && this.props.asset.tags.map(x => {
                return <Tag buttonText={x}
                  isSelected={true}
                  tag={x}
                  onClicked={this.handleRemoveTag}
                />})}
                </div>
               
                
                <div className="input-group p-2">
                <input
                    className="input-group-field"
                    type="text"
                    value={this.state.searchText}
                    placeholder="Search tags"
                    onChange={this.handleSearch}
                  />
                  <span className="input-group-label">
                    <Icon title="Search" name="search" size="1rem" />
                  </span>
                </div>
                
                <div>
                  <p className="p-2 text-bold">Assets Tags</p>
     
                <div className="flex flex-ai-c flex-wrap"  style={{ maxHeight: '11rem', overflowY: 'auto', maxWidth:'100%', }}>
                {this.props.assetTags &&
                  this.props.assetTags
                  .filter(tag => tag.name.toLowerCase().includes(this.state.searchText))
                  .filter(tag => 
                    assetsTags && 
                    !assetsTags.some(assetTag => assetTag.toLowerCase() === tag.name.toLowerCase())
                  )
                    .map(x => (
                      <Tag
                        buttonText={x.name}
                        isSelected={false}
                        tag={x}
                        onRemove={this.handleAddTag}
                        onDelete={this.handleDeleteAssetTag}
                      />
                    ))}
                </div>
              
                </div>
                  <div>
                  <p className="p-2 text-bold">Device Tags</p>
                  <div className="flex flex-ai-c flex-wrap"  style={{ maxHeight: '11rem', overflowY: 'auto', maxWidth:'100%', }}>
                  {this.props.deviceTags &&
                  this.props.deviceTags
                  .filter(tag => tag.name.toLowerCase().includes(this.state.searchText))
                  .filter(tag => 
                    assetsTags && 
                    !assetsTags.some(assetTag => assetTag.toLowerCase() === tag.name.toLowerCase())
                  )
                    .map(x => (
                      <Tag
                        buttonText={x.name}
                        isSelected={false}
                        tag={x}
                        onRemove={this.handleAddTag}
                      />
                    ))}
                    </div>
        
                  </div>

              
                </div>
                <div className="pad-1 text-center pb flex flex-jc-sb">
                  <div></div>
                 <div>
                
                  <button className="button" onClick={this.handleToggleEdit}>
                    Close{" "}
                  </button>
                 </div>
                </div>
              </Popup>
            )}
            {this.getMetadataView()}
          </React.Fragment>
        )}
        {!asset && (
          <div>
            <h1>Loading</h1>
          </div>
        )}
      </Page>
    );
  }
}

export default connect(
  (state, { match }) => ({
    asset: getAsset(state, parseInt(match.params.id, 10)),
    profile: getProfile(state),
    transcodedVideos: state.uiState.videoTranscoding.transcodedVideos, 
    deviceTags: getDeviceTagsAll(state),
    assets: getFilteredAssetsByQuery(state, ""),
    assetTags: getAssetTagsAll(state),


  }),
  {
    fetchAssets,
    updateAsset,
    updateImageAsset,
    updateAudioAsset,
    updateVideoAsset,
    setAssetTags,
    setPageTitle,
    transcodeVideo,
    fetchDeviceTags,
    fetchAssetTags,
    addAssetTag,
    deleteAssetTag,
  }
)(AssetPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AssetPage/index.js